import React from "react";
import { MenuItem } from "@material-ui/core";
import DPSelect from "Components/DP/DPSelect/DPSelect";
import { useRewards } from "../../useRewards";
import { RewardStatus, rewardStatusDictionary } from "Shared/types/Rewards";

const FILTER_STATUSES = [
  RewardStatus.pendingApproval,
  RewardStatus.approved,
  RewardStatus.rejected,
  RewardStatus.paid,
  RewardStatus.withheld,
];

export function StatusFilter() {
  const { status, onChangeStatus } = useRewards();

  const options = [
    { label: "All", value: "" },
    ...FILTER_STATUSES.map(status => {
      return {
        label: rewardStatusDictionary[status],
        value: status,
      };
    }),
  ];

  return (
    <DPSelect
      inputLabel="Status"
      selectedIndex={
        status
          ? options.findIndex(option => option.value === status)
          : undefined
      }
      onIndexChanged={(index) => {
        onChangeStatus(options[index].value as RewardStatus | undefined);
      }}
    >
      {options.map((option, index) => (
        <MenuItem key={option.value} value={index}>
          <span>{option.label}</span>
        </MenuItem>
      ))}
    </DPSelect>
  );
}
